import React, { Component } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useCart } from '../../lib/cart';
export function Footer() {
  const {
    slug: urlSlug
  } = useParams<{
    slug: string;
  }>();
  const {
    cart
  } = useCart();
  // Emilius "white-label" mode — sin links al marketplace de NOIZA.
  // Mismo discriminador que MarketplaceHeader: URL o slug del carrito.
  const isEmiliusFlow = urlSlug === 'emilius-pizza' || cart.restaurantSlug === 'emilius-pizza';
  if (isEmiliusFlow) {
    return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-6 mt-auto" data-id="element-1878">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-2 text-center" data-id="element-1879">
          <p className="text-white/40 text-xs" data-id="element-1880">
            © {new Date().getFullYear()} Emilius Pizza. Todos los derechos
            reservados.
          </p>
          <p className="text-[10px] tracking-wide text-white/25 select-none" aria-label="Powered by noizacr.com" data-id="element-1881">
            Powered by noizacr.com
          </p>
        </div>
      </footer>;
  }
  return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-12 mt-auto" data-id="element-1882">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1883">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1884">
          <div className="col-span-1 md:col-span-2" data-id="element-1885">
            <div className="flex items-center gap-2 mb-4" data-id="element-1886">
              <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-1887">
                <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-1888">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-1889">
                NOIZA
              </span>
            </div>
            <p className="text-white/40 max-w-sm mb-6" data-id="element-1890">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-1891">
            <h4 className="font-semibold text-white mb-4" data-id="element-1892">Explorar</h4>
            <ul className="space-y-3" data-id="element-1893">
              <li data-id="element-1894">
                <Link to="/" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1895">
                  Inicio
                </Link>
              </li>
              <li data-id="element-1896">
                <Link to="/restaurants" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1897">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-1898">
                <Link to="/cart" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1899">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-1900">
            <h4 className="font-semibold text-white mb-4" data-id="element-1901">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-1902">
              <li data-id="element-1903">
                <Link to="/onboarding" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1904">
                  Únete a NOIZA
                </Link>
              </li>

              <li data-id="element-1905">
                <a href={`https://wa.me/50688118105?text=${encodeURIComponent('Hola, requiero soporte con: _________\n\nNombre del restaurante:\nCorreo electrónico registrado:\nNombre de quien contacta:')}`} target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1906">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1907">
          <p className="text-white/30 text-sm" data-id="element-1908">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-1909">
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-1910">
              Términos
            </Link>
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-1911">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}